import { render, staticRenderFns } from "./NewRead.vue?vue&type=template&id=e5a73fbc&scoped=true&"
import script from "./NewRead.vue?vue&type=script&lang=js&"
export * from "./NewRead.vue?vue&type=script&lang=js&"
import style0 from "./NewRead.vue?vue&type=style&index=0&id=e5a73fbc&prod&lang=less&scoped=true&"
import style1 from "./NewRead.vue?vue&type=style&index=1&id=e5a73fbc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a73fbc",
  null
  
)

export default component.exports